import { TPartner } from "@/services/requests/Voucher/types";

export const getPartnerLabel = (partnerAlias: string, partnerList: TPartner[]): string => {

  if (!partnerList || partnerList.length === 0) {
    return "Congenere"; 
  }


  const partner = partnerList.find(partn => partn.partnerAlias === partnerAlias);
  if (!partner) {
    return "Congenere"; 
  }


  const hasG3 = partnerList.some(p => p.partnerAlias === "G3");


  if (partner.partnerAlias === "G3") {
    return "Gol";
  }
  if (partner.partnerAlias === "A3") {
    return hasG3 ? "Todas" : "Congenere";
  }


  return partner.partnerCompanyName;
};
